import React, { Component } from 'react';
import WaveSurfer from 'wavesurfer.js';
import Utils from '@/utils';
import moment from 'moment';
import AudioWorkWaveformItemRender from './children/AudioWorkWaveformItemRender';

import '@/assets/audioAddMusic.less';

class AudioWorkWaveformItemFunction extends Component {
  constructor(props) {
    super(props);
    this.state = {
      audioAccept: '.wav,.mp3,.m4a,.aac,.ogg',
      workPlaceVisible: true,
      duration: '00:00.00',
      playing: false,
      start: '00:00.00',
      end: '00:00.00',
      waveformWidth: 100,
      isLarge: false,
      isNotAllowDrag: false,
      limitLeft: 0,
      limitRight: 0,
      startPercent: 0,
    };
    this.wavesurferRef = React.createRef();
    this.coverLeftRef = React.createRef();
    this.coverRightRef = React.createRef();
    this.rangRef = React.createRef();
    this.wavesurfer = null;
    this.isCanChangeSliderValue = false;
    this.isChangeSliderDrag = false;
  }

  getWaveformWidth = () => {
    const { audioAddMusicList, index } = this.props;
    const audioAddMusicItem = { ...this.props.audioAddMusicItem };
    let waveformWidth = 100;
    let lastWaveformWidth = this.state.waveformWidth;
    if (audioAddMusicList.length < 2) {
      audioAddMusicItem.dragX = 0;
      audioAddMusicItem.isLarge = true;
    } else {
      let otherItemIndex = index === 0 ? 1 : 0;
      let currentDuration = Utils.getSeconds(audioAddMusicItem.duration);
      let otherDuration = Utils.getSeconds(
        audioAddMusicList[otherItemIndex].duration
      );
      if (currentDuration >= otherDuration) {
        audioAddMusicItem.dragX = 0;
        audioAddMusicItem.isLarge = true;
      } else {
        audioAddMusicItem.isLarge = false;
        waveformWidth = currentDuration / (otherDuration / 100);
      }
    }
    this.props.handleAudioItemChange(audioAddMusicItem);
    this.setState({ waveformWidth }, () => {
      if (waveformWidth !== lastWaveformWidth) {
        if (this.wavesurfer) {
          //重新绘制宽度
          this.setState({
            limitRight:
              audioAddMusicItem.wavesurferContRef.current.clientWidth -
              40 -
              this.wavesurfer.drawer.container.clientWidth,
          });
          this.wavesurfer.drawer.containerWidth =
            this.wavesurfer.drawer.container.clientWidth;
          this.wavesurfer.drawBuffer();
        }
      }
    });
  };

  componentDidMount() {
    this.getWaveformWidth();
    this.wavesurfer = WaveSurfer.create({
      barHeight: 0.8,
      backend: 'MediaElement',
      container: this.wavesurferRef.current,
      waveColor: '#8372FF',
      progressColor: '#8372FF',
      backgroundColor: '#261F3F',
      height: 160,
      cursorWidth: 0,
      hideScrollbar: true,
      fillParent: true,
    });
    this.wavesurfer.on('audioprocess', () => {
      let currentTimeNumber = this.wavesurfer.getCurrentTime();
      if (this.wavesurfer.isPlaying()) {
        if (this.props.audioAddMusicItem.isLarge) {
          this.props.getTrackCurrentTimePercent(
            (currentTimeNumber / this.wavesurfer.getDuration()) * 100
          );
          if (
            currentTimeNumber >=
              Utils.getSeconds(this.props.audioAddMusicItem.end) ||
            currentTimeNumber <=
              Utils.getSeconds(this.props.audioAddMusicItem.start)
          ) {
            this.wavesurfer.setVolume(0);
          } else {
            this.wavesurfer.setVolume(this.props.audioAddMusicItem.volume);
          }
        } else {
          if (
            currentTimeNumber >
              Utils.getSeconds(this.props.audioAddMusicItem.end) ||
            currentTimeNumber <
              Utils.getSeconds(this.props.audioAddMusicItem.start)
          ) {
            this.wavesurfer.pause();
          }
        }
      }
    });
    this.wavesurfer.on('finish', () => {
      console.log('播放完毕');
    });
    this.wavesurfer.on('interaction', () => {
      if (!this.wavesurfer.isPlaying()) {
      }
    });
    this.wavesurfer.on('pause', () => {
      console.log('播放暂停');
    });
    this.wavesurfer.on('play', () => {
      console.log('播放播放');
    });
    this.wavesurfer.on('ready', () => {
      console.log('加载完毕');
      const audioAddMusicItem = { ...this.props.audioAddMusicItem };
      audioAddMusicItem.wavesurfer = this.wavesurfer;
      this.setState({
        limitRight:
          audioAddMusicItem.wavesurferContRef.current.clientWidth -
          40 -
          this.wavesurfer.drawer.container.clientWidth,
      });
      this.props.handleAudioItemChange(audioAddMusicItem);
    });
    this.wavesurfer.load(this.props.audioAddMusicItem.videofileurl);
    if (this.rangRef.current.sliderRef) {
      this.rangRef.current.sliderRef?.addEventListener('mousedown', () => {
        if (this.isCanChangeSliderValue) {
          this.isChangeSliderDrag = true;
        }
      });
      this.rangRef.current.sliderRef?.addEventListener('mouseup', () => {
        this.isChangeSliderDrag = false;
      });
      this.rangRef.current.sliderRef?.addEventListener('mouseleave', (e) => {
        if (
          (e.toElement && !e.toElement.getAttribute('class')) ||
          (e.toElement.getAttribute('class') &&
            e.toElement.getAttribute('class').indexOf('ant-slider-handle') !==
              0)
        ) {
          this.isChangeSliderDrag = false;
        }
      });
      this.rangRef.current.sliderRef?.addEventListener('mousemove', (e) => {
        if (e.target.getAttribute('class').includes('ant-slider-handle')) {
          this.isCanChangeSliderValue = true;
        } else if (this.isChangeSliderDrag === false) {
          this.isCanChangeSliderValue = false;
        }
      });
    }
  }

  getCutPercent = (value) => {
    const d = Utils.getSeconds(this.props.audioAddMusicItem.duration);
    const t = Utils.getSeconds(value);
    return (t / d) * 100;
  };

  handleRangeChange = (value) => {
    if (!this.isCanChangeSliderValue) {
      return false;
    }
    this.setState({ isNotAllowDrag: true });
    this.props.handlePauseAllAudio();
    let coverLeftWidth = this.coverLeftRef.current.clientWidth;
    let coverRightWidth = this.coverRightRef.current.clientWidth;
    let waveformContWidth =
      this.props.audioAddMusicItem.wavesurferContRef.current.clientWidth - 40;
    let waveformWidth = this.wavesurfer.drawer.container.clientWidth;
    let waveformLeftWidth = (value[0] / 100) * waveformWidth;
    this.setState({
      limitLeft: -coverLeftWidth,
      limitRight: waveformContWidth - waveformWidth + coverRightWidth,
    });
    const d = Utils.getSeconds(this.props.audioAddMusicItem.duration);
    this.setState({ miniLengthLimit: false });
    this.setState({ maxLengthLimit: false });
    const audioAddMusicItem = { ...this.props.audioAddMusicItem };
    audioAddMusicItem.start = moment('00:00:00', 'mm:ss:SS')
      .add((d * value[0]) / 100, 'seconds')
      .format('mm:ss:SS')
      .replace(/:([^:]*)$/, '.$1');
    audioAddMusicItem.end = moment('00:00:00', 'mm:ss:SS')
      .add((d * value[1]) / 100, 'seconds')
      .format('mm:ss:SS')
      .replace(/:([^:]*)$/, '.$1');
    // this.wavesurfer.setCurrentTime(this.wavesurfer.getDuration() * (value[0] / 100));
    audioAddMusicItem.startPercent =
      ((this.props.audioAddMusicItem.dragX + waveformLeftWidth) /
        waveformContWidth) *
      100;
    this.props.handleAudioItemChange(audioAddMusicItem);
    this.props.getTrackEndTimePercent(audioAddMusicItem.end, this.props.index);
    this.props.getTrackStartTimePercent(
      audioAddMusicItem.start,
      this.props.index
    );
  };

  handleVolumeChange = (value) => {
    const audioAddMusicItem = { ...this.props.audioAddMusicItem };
    audioAddMusicItem.volume = value;
    this.props.audioAddMusicItem.wavesurfer.setVolume(value);
    this.props.handleAudioItemChange(audioAddMusicItem);
  };

  handleDrag = (e, ui) => {
    this.props.handlePauseAllAudio();
    let coverLeftWidth = this.coverLeftRef.current.clientWidth;
    let waveformContWidth =
      this.props.audioAddMusicItem.wavesurferContRef.current.clientWidth - 40;
    let largeItem = this.props.audioAddMusicList.filter(
      (item) => item.isLarge
    )[0];
    const audioAddMusicItem = { ...this.props.audioAddMusicItem };
    audioAddMusicItem.dragX = audioAddMusicItem.dragX + ui.deltaX;
    audioAddMusicItem.dragXTime =
      (audioAddMusicItem.dragX / waveformContWidth) *
      largeItem.wavesurfer.getDuration();
    audioAddMusicItem.startPercent =
      ((audioAddMusicItem.dragX + coverLeftWidth) / waveformContWidth) * 100;
    this.props.handleAudioItemChange(audioAddMusicItem);
    let timer = setTimeout(() => {
      this.props.getTrackEndTimePercent(
        audioAddMusicItem.end,
        this.props.index
      );
      this.props.getTrackStartTimePercent(
        audioAddMusicItem.start,
        this.props.index
      );
      clearTimeout(timer);
    }, 500);
  };

  onAudioPlay = () => {
    const { isLarge, startPercent, end, wavesurfer, dragXTime } =
      this.props.audioAddMusicItem;
    if (!isLarge) {
      if (
        this.props.trackCurrentTimePercent >= startPercent &&
        !this.wavesurfer.isPlaying() &&
        this.wavesurfer.getCurrentTime() <= Utils.getSeconds(end)
      ) {
        let largeItem = this.props.audioAddMusicList.filter(
          (item) => item.isLarge
        )[0];
        const currentTime = largeItem.wavesurfer.getCurrentTime() - dragXTime;
        this.wavesurfer.setCurrentTime(
          currentTime < 0
            ? 0
            : currentTime > wavesurfer.getDuration()
            ? wavesurfer.getDuration()
            : currentTime
        );
        this.wavesurfer.play();
      } else if (this.props.trackCurrentTimePercent <= startPercent) {
        this.wavesurfer.pause();
      }
    }
  };

  componentWillUnmount() {
    if (this.wavesurfer) {
      if (this.wavesurfer.isPlaying()) {
        this.wavesurfer.pause();
      }
      this.wavesurfer.destroy();
      this.wavesurfer = null;
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.audioAddMusicList.length !== this.props.audioAddMusicList.length
    ) {
      this.getWaveformWidth();
    }
    if (
      prevProps.trackCurrentTimePercent !==
        this.props.trackCurrentTimePercent &&
      this.props.playing
    ) {
      this.onAudioPlay();
    }
  }

  render() {
    return (
      <AudioWorkWaveformItemRender
        limitLeft={this.state.limitLeft}
        limitRight={this.state.limitRight}
        waveformWidth={this.state.waveformWidth}
        coverLeftRef={this.coverLeftRef}
        coverRightRef={this.coverRightRef}
        wavesurferRef={this.wavesurferRef}
        wavesurferContRef={this.props.audioAddMusicItem.wavesurferContRef}
        isLarge={this.props.audioAddMusicItem.isLarge}
        isNotAllowDrag={this.state.isNotAllowDrag}
        audioAddMusicItem={this.props.audioAddMusicItem}
        getCutPercent={this.getCutPercent}
        handleDeleteAudioJoinerItem={this.props.handleDeleteAudioJoinerItem}
        handleRangeChange={this.handleRangeChange}
        handleAllowDrag={(isNotAllowDrag) => this.setState({ isNotAllowDrag })}
        handleVolumeChange={this.handleVolumeChange}
        handleDrag={this.handleDrag}
        dragX={this.props.audioAddMusicItem.dragX}
        rangRef={this.rangRef}
      />
    );
  }
}

export default AudioWorkWaveformItemFunction;
